import { frontArticles4Memu } from '@/api/api';

export const methodsMixins = {
  methods: {
    getArticles(memu1Id, memu2Id, list) {
      frontArticles4Memu({ memu1Id, memu2Id, pageNumber: 1, pageSize: 100 }).then(res => {
        if(res.data.list) {
          list.push(...res.data.list);
        }
      })
    },
    menu1Article(memu1Id) {
      document.documentElement.scrollTop = 0
      this.$router.push({
        path: '/column',
        query: {
          memu1Id
        }
      })
    },
    artilceIdArticle(articleId, articleUrl) {
      if(articleUrl) {
        window.open(articleUrl)
      } else {
        const { origin, pathname } = window.location;
        window.open(origin + pathname + `#/article?articleId=${ articleId }`)
        // this.$router.push({
        //   path: '/article',
        //   query: {
        //     articleId
        //   }
        // })
      }
    }
  }
}